import ComposeSurfaceActions from 'owa-surface-actions-option/lib/ComposeSurfaceActionsOption';
import ReadSurfaceActions from 'owa-surface-actions-option/lib/ReadSurfaceActionsOption';
var surfaceActionsSubCategory = {
    key: 'surfaceActions',
    titleStringKey: 'optionSubcategory_surfaceActions',
    options: [ReadSurfaceActions, ComposeSurfaceActions],
};
export default surfaceActionsSubCategory;
//# sourceMappingURL=surfaceActionsSubcategory.js.map